import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

import Website from './pages/website/Website';
import AdminLogin from './pages/website/AdminLogin';
import AdminPasswordUpdate from './pages/website/AdminPasswordUpdate';
import SuperAdminLogin from './pages/website/SuperAdminLogin';
import EmployeeLogin from './pages/website/EmployeeLogin';
import Admin from './pages/admin/Admin';
import SuperAdminDashboard from './pages/superAdmin/SuperAdminDashboard';
import AppLayout from './pages/layouts/admin/AppLayout';
import SuperAdminAppLayout from './pages/layouts/superAdmin/SuperAdminAppLayout';
import ProtectedRoute from './components/auth/ProtectedRoute';
import AdminProtectedRoute from './components/auth/AdminProtectedRoute';
import SuperAdminAdmin from './pages/superAdmin/admin/SuperAdminAdmin';
import SuperAdminCenter from './pages/superAdmin/centers/SuperAdminCenter';
import AdminCounselors from './pages/admin/AdminCounselors';
import EmployeeDashboard from './pages/employee/EmployeeDashboard';
import EmployeeProtectedRoutes from './components/auth/EmployeeProtectedRoutes';
import EmployeePasswordUpdate from './pages/website/EmployeePasswordUpdate';
import EmployeeAppLayout from './pages/layouts/employee/EmployeeAppLayout';
import EmployeeCallHistory from './pages/employee/EmployeeCallHistory';
import EmployeeCallHistoryDetails from './pages/employee/EmployeeCallHistoryDetails';
import EmployeeCallConversion from './pages/employee/EmployeeCallConversion';
import EmployeeCallConversionDetails from './pages/employee/EmployeeCallConversionDetails';
import EmployeeProfile from './pages/employee/EmployeeProfile';
import EmployeeTodoList from './pages/employee/EmployeeTodoList';
import AppReleaseSuperAdmin from './pages/superAdmin/appRelease/AppReleaseSuperAdmin';
import AdminCallConversion from './pages/admin/AdminCallConversion';
import AdminCounselorsCalls from './pages/admin/AdminCounselorsCalls';
import AdminCallDetials from './pages/admin/AdminCallDetials';
import AdminTask from './pages/admin/AdminTask';
import AdminLeads from './pages/admin/AdminLeads';
import EmployeeLeads from './pages/employee/EmployeeLeads';
import AboutWeb from './pages/website/AboutWeb';
import ContactWeb from './pages/website/ContactWeb';

function App() {
  return (
    <BrowserRouter>
     <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<Website />} />
        <Route path="/about" element={<AboutWeb />} />
        <Route path="/contact" element={<ContactWeb />} />
        <Route path="/admin-login" element={<AdminLogin />} />
        <Route path="/admin/update-password" element={<AdminPasswordUpdate />} />
        <Route path="/super-admin-login" element={<SuperAdminLogin />} />
        <Route path="/employee-login" element={<EmployeeLogin />} />
        <Route path="/employee/update-password" element={<EmployeePasswordUpdate />} />

        {/* Protected admin routes */}
        <Route path="/admin" element={<AdminProtectedRoute />}>
          <Route element={<AppLayout />}>
            <Route path="dashboard" element={<Admin />} />
            <Route path="counselors" element={<AdminCounselors />} />
             <Route path="counselors/calls/:id" element={<AdminCounselorsCalls />} />
              <Route path="counselors/calls-details/:id" element={<AdminCallDetials />} />
            <Route path="call-conversion" element={<AdminCallConversion />} />
            <Route path="tasks" element={<AdminTask />} />
            <Route path="leads" element={<AdminLeads />} />
          </Route>
        </Route>

         <Route path="/employee" element={<EmployeeProtectedRoutes />}>
          <Route element={<EmployeeAppLayout />}>
            <Route path="dashboard" element={<EmployeeDashboard />} />
            <Route path="calls-history" element={<EmployeeCallHistory />} />
            <Route path="calls-history/detail/:id" element={<EmployeeCallHistoryDetails />} />
            <Route path="call-conversions" element={<EmployeeCallConversion />} />
            <Route path="call-conversions/detail/:id" element={<EmployeeCallConversionDetails />} />
            <Route path="profile" element={<EmployeeProfile />} />
            <Route path="todo-list" element={<EmployeeTodoList />} />
            <Route path="leads" element={<EmployeeLeads />} />
          </Route>
        </Route>

        {/* Protected super admin routes */}
        <Route path="/super-admin" element={<ProtectedRoute allowedRoles={['superAdmin']} />}>
          <Route element={<SuperAdminAppLayout />}>
            <Route path="dashboard" element={<SuperAdminDashboard />} />
            <Route path="admins" element={<SuperAdminAdmin />} />
            <Route path="centers" element={<SuperAdminCenter />} />
            <Route path="app_release" element={<AppReleaseSuperAdmin />} />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
